import React from 'react'

const ComponentNotFound = (props) => (
    <div style={{ padding: '10vw 0', textAlign: 'center' }}>
        <p>Component {props.blok.component} is not defined. Add it to components.js</p>
    </div>
)

export default ComponentNotFound